import Panel from 'components/Insights/Charts/View/EventsByUserTable/Panel';

export default Panel;
